/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForGcpSaasUserManagedOnboarded extends models.StorageConfigurationBaseForGcpSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForGcpSaasUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForGcpSaasUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForGcpSaasUserManagedOnboarded>): StorageConfigurationForGcpSaasUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForGcpSaasUserManagedOnboarded(), model);
        StorageConfigurationForGcpSaasUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForGcpSaasUserManagedOnboarded>): StorageConfigurationForGcpSaasUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForGcpSaasUserManagedOnboarded.newInstance(<StorageConfigurationForGcpSaasUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForGcpSaasUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForGcpSaasUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForGcpSaasUserManagedOnboarded): boolean {
        if (models.StorageConfigurationBaseForGcpSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForGcpSaasUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the GCS bucket is present.
     */
    account_id: string;

}
